<template>
    <div>
        <page-title>用户管理</page-title>
        <page-body>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="mobile" label="用户">
                    <template slot-scope="scope">
                        <div>手机号: {{scope.row.mobile}}</div>
                        <div>QQ号: {{scope.row.qq}}</div>
                        <div>称呼: {{scope.row.name}}</div>
                        <div v-if="scope.row.admin" style="color: #ff8431"><i class="el-icon-star-on"></i>管理员</div>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="站点">
                    <template slot-scope="scope">
                        <template v-if="scope.row.hostsCount">
                            <router-link :to="'/dashboard/admin/host/index?user_id=' + scope.row.id">
                                {{scope.row.hostsCount.value}}
                            </router-link>
                        </template>
                        <template v-else>0</template>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <router-link :to="'/dashboard/admin/user/edit?id=' + scope.row.id">编辑</router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="deleteUser(scope.row)">删除</el-button>
                        </template>
                        <template v-else>
                            <span style="color: #909399">已删除</span>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="recoveryUser(scope.row)">恢复</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            list: null,
            pagination: null,
            keyword: ''
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/user/index',
                    params: {
                        page: page,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteUser(user) {
            new Promise(resolve => {
                if (user.admin) {
                    this.$prompt('此操作将删除该用户, 是否继续?<br>这是一个管理员账户，您需要输入他的手机号以确认删除:', '提示', {
                        inputPlaceholder: '请输入用户的手机号',
                        dangerouslyUseHTMLString: true
                    }).then(({value}) => {
                        if (value === user.mobile) {
                            resolve(user)
                        } else {
                            this.$message.warning('手机号不正确。')
                        }
                    }).catch(() => {
                    })
                } else {
                    this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        resolve(user)
                    }).catch(() => {
                    })
                }
            }).then(user => {
                this.loading = true
                axios({
                    url: 'admin/user/delete',
                    params: {
                        id: user.id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        user.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryUser(user) {
            this.loading = true
            axios({
                url: 'admin/user/recovery',
                params: {
                    id: user.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    user.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
